import { Flex, Icon, Text } from '@chakra-ui/react';
import { useIsMobile } from '~/common/hooks/useIsMobile';
import { IndigoLogoSmall } from '~/common/icons';
import { useListingPageContext } from '../../ListingPageContext';
import { DataSourceTooltip } from './DataSourceTooltip';

export const DataSource = () => {
  const isMobile = useIsMobile();
  const { confidence } = useListingPageContext();

  return (
    <Flex alignItems="center" gap={1.5}>
      <Text color="whiteAlpha.700" fontSize={{ base: 'sm', md: 'md' }}>
        Powered By
      </Text>
      <Text fontSize={{ base: 'sm', md: 'md' }} fontWeight="medium">
        MLS
      </Text>
      <Text color="whiteAlpha.700" fontSize={{ base: 'sm', md: 'md' }}>
        and
      </Text>
      <Icon as={IndigoLogoSmall} color="cyan.500" />
      <Text fontSize={{ base: 'sm', md: 'md' }} fontWeight="medium">
        Indigo Offer Data
      </Text>
      {!!confidence && (
        <DataSourceTooltip label={isMobile ? 'Details' : 'View Details'} />
      )}
    </Flex>
  );
};
